import React from 'react';

import { ProgressLoader, Text } from 'Modules/ui';
import { useTranslation } from 'Modules/core/i18n';

import styles from './index.module.scss';


export const ApplicationInitializer = () => {
    const { t } = useTranslation('system');
    return (
        <div className={styles.initializer}>
            <Text component='span' textType='info' className={styles.content}>
                <ProgressLoader indeterminate className={styles.loader} />
                <span>
                    {t('initializing')}
                </span>
            </Text>
        </div>
    );
};
